import { Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import UserAvatar from "components/react-lib/generic-ui/UserAvatar";
import MessageMenu from "./MessageMenu";
import BotAvatar from "components/bot/BotAvatar";
import MessageAudio from "./MessageAudio";
import MessageControls from "./MessageControls";
import { useTheme } from "@emotion/react";

export default function MessageContainer({
  message,
  children,
  inContext,
  canDelete = true,
  canUseAsPrompt = true,
}) {
  // This variable is used to update the UI immediatily
  const [processingAudio, setProcessingAudio] = useState(
    Boolean(message.processingAudio)
  );

  const theme = useTheme();

  const chatState = useSelector((state) => state.chat);
  const processing = Boolean(chatState.botProcessing[message.botId]);
  const isAi = message.role === "assistant";

  const renderAvatar = () => {
    if (isAi) {
      return <BotAvatar botId={message.botId} />;
    }
    return <UserAvatar />;
  };

  return (
    <div
      data-testclass="chat-message-container"
      style={{
        backgroundColor:
          message.role === "assistant" ?  theme.palette.conversationBackground.default : theme.palette.conversationBackground.active,
        zIndex: 1,
        paddingTop: 20,
        paddingBottom: 10,
        paddingLeft: 16,
        paddingRight: 16,
        borderRadius: 24,
        position: "relative",
        width: "100%",
        boxSizing: "border-box",
        maxWidth: "748px",
      }}
    >
      <Stack direction="row" justifyContent="space-between">
        {renderAvatar()}
        {!message.streaming && !message.hasError && (
          <MessageMenu
            canDelete={canDelete}
            message={message}
            setProcessingAudio={setProcessingAudio}
            canUseAsPrompt={canUseAsPrompt}
          />
        )}
      </Stack>
      {children}
      {!message.streaming && !message.hasError && (
        <MessageAudio processingAudio={processingAudio} message={message} />
      )}
      {!message.streaming && !message.hasError && (
        <MessageControls message={message} inContext={inContext} processing={processing} />
      )}
    </div>
  );
}
